import Vue from "vue";
import { includes, filter } from "lodash";
import ApiService from "@/api";
import localforage from "localforage";
export default class MessagingService {
    constructor() {
        this.messaging = Vue.prototype.$messaging;
        // Token refresh event
        this.messaging.onTokenRefresh(() => {
            this.messaging
                .getToken()
                .then(refreshedToken => {
                    this.setTokenSentToServerFlg(false);
                    this.sendTokenToServerAsync(refreshedToken);
                })
                .catch(err => {
                    console.log("Unable to retrieve refreshed token ", err);
                });
        });

        // Receiving message event
        const _this = this;
        this.messaging.onMessage(function(payload) {
            // console.log("Message received", payload);
            localforage.getItem("areInCampings").then(areInCampingsObject => {
                const { data } = payload;
                const areInCampings = (areInCampingsObject || []).map(item =>
                    Number(item.id)
                );
                const campings = data.campings ? JSON.parse(data.campings) : [];
                const swRegistration = _this.messaging.swRegistration;
                const notificationTitle = data.title.split('\\').join(''); //eslint-disable-line
                let matchCampings = filter(campings, camping =>
                    includes(areInCampings, Number(camping.id))
                );
                console.log("message background", data);
                if (matchCampings.length === 0 && !data.is_to_all) {
                    return;
                }
                const notificationOptions = {
                    body: data.body.split('\\').join(''), //eslint-disable-line
                    icon: "./img/noti.png",
                    data: { url: data.links }
                };
                return swRegistration.showNotification(
                    notificationTitle,
                    notificationOptions
                );
            });
        });
    }

    /* Notifications are supported and not refused by the visitor */
    canNotify() {
        return (
            typeof window.Notification !== "undefined" &&
            window.Notification.permission !== "denied"
        );
    }

    /* Request user's permission (once); a refusal is remembered by the browser, not an error */
    async requestPermissionAsync() {
        if (!this.canNotify()) {
            return false;
        }
        if (window.Notification.permission === "granted") {
            return true;
        }
        if (window.localStorage.getItem("isRequestPermission") === "true") {
            return false;
        }
        const permission = await window.Notification.requestPermission();
        window.localStorage.setItem("isRequestPermission", "true");
        return permission === "granted";
    }

    /* Get messaging token; only meaningful once the visitor has granted notifications */
    async getTokenAsync() {
        if (!this.canNotify() || window.Notification.permission !== "granted") {
            this.setTokenSentToServerFlg(false);
            return false;
        }
        try {
            let currentToken = await this.messaging.getToken();
            if (currentToken) {
                await this.sendTokenToServerAsync(currentToken);
                return currentToken;
            }
            this.setTokenSentToServerFlg(false);
            return false;
        } catch (err) {
            console.log("An error occurred while retrieving token. ", err);
            this.setTokenSentToServerFlg(false);
            return false;
        }
    }

    /* Delete Instance ID token */
    async deleteTokenAsync() {
        try {
            let currentToken = await this.messaging.getToken();
            await this.messaging.deleteToken(currentToken);
            this.setTokenSentToServerFlg(false);
            console.log("Token deleted: " + currentToken);
        } catch (err) {
            console.log("Unable to delete token. ", err);
        }
    }

    // Send the Instance ID token your application server, so that it can:
    // - send messages back to this app
    // - subscribe/unsubscribe the token from topics
    async sendTokenToServerAsync(currentToken) {
        try {
            if (!this.isTokenSentToServer(currentToken)) {
                this.saveDeviceToken(currentToken);
                this.setTokenSentToServerFlg(currentToken);
            }
        } catch (err) {
            console.log("Unable to send token to server", err);
        }
    }

    isTokenSentToServer(currentToken) {
        return window.localStorage.getItem("sentToServer") === currentToken;
    }

    setTokenSentToServerFlg(sent) {
        window.localStorage.setItem("sentToServer", sent ? sent : "0");
    }
    saveDeviceToken(token) {
        localforage.getItem("lang").then(lang => {
            return new Promise(resolve => {
                let url = `update-token/?token=${token}`;
                if (lang === "en") {
                    url = `en/update-token/?token=${token}`;
                }
                ApiService.get(url)
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch(() => {});
            });
        });
    }
}
